exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".promo-container{margin-bottom:20px}.promo-container .input.form-control{background-color:#fff;border:1px solid #b8babd;width:98%}.promo-container .input.form-control:disabled{background-color:inherit}.promo-container .input-group{width:60%}.promo-container .input-group-btn .btn.btn-default{min-width:inherit;border:0;border-radius:4px;border-radius:0;padding:8px;min-width:40px;min-height:0;max-height:34px}.promo-container .input-group-btn .btn.btn-default:disabled{background-color:#545454}.promo-label{font-weight:700;font-size:.9rem;padding-top:20px;border-top:2px solid #eee;width:100%;color:#545454}.promo-response{padding-top:4px;font-size:.7rem;font-weight:400;color:#eb4e00}.promo-success{color:#109610}.promo-error{color:#d90000}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/payment/PromoCode/PromoCode.scss
 ** module id = 1253
 ** module chunks = 0
 **/